<div class="about-content" >
  <div class="about-desc">
    <h5 style="color: var(--primary-color)">{{data.title}}</h5>
    <p>
      {{data.content}}
    </p>
  </div>
  <div class="about-image mission-image">
    <img [src]="data.imgsrc" alt="template image" />
  </div>
</div>
